/**
 * Theme toggle (port of crates/rm-ui/src/theme.rs). The `dark` class lives on
 * <html>; CSS vars swap via :root.dark. The default comes from the build (on in
 * index.html, off for Plotea); public/theme-init.js applies the remembered
 * choice before the first paint.
 */
import { useSyncExternalStore } from 'react'

const THEME_STORAGE_KEY = 'app-theme'

function htmlHasDark(): boolean {
  return (
    typeof document !== 'undefined' &&
    document.documentElement.classList.contains('dark')
  )
}

function subscribe(onChange: () => void) {
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  })
  return () => observer.disconnect()
}

function toggle() {
  const dark = document.documentElement.classList.toggle('dark')
  try {
    localStorage.setItem(THEME_STORAGE_KEY, dark ? 'dark' : 'light')
  } catch {
    // Storage blocked: the choice lasts until the page reloads.
  }
}

export function useTheme() {
  const dark = useSyncExternalStore(subscribe, htmlHasDark, () => true)
  return { dark, toggle }
}
